import React, { useState } from 'react';
import { Button, TextField, Typography, Grid, useMediaQuery, useTheme, InputAdornment } from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox'; 
import LockOpenIcon from '@mui/icons-material/LockOpen'; 
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Login.css'; 

function Login() {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const { login } = useAuth();

   const handleLogin = async (event) => {
    event.preventDefault();

    if (usernameOrEmail === '' || password === '') { 
      setErrorMessage('Please fill in both fields.');
      return;
    }

    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ usernameOrEmail, password }), 
      });

      const data = await response.json();

      if (response.ok) {
        const userResponse = await fetch(`https://api.hub4food.colab4food.com/api/users/${data.userId}`);
        const userData = await userResponse.json();

        if (!userResponse.ok) {
          throw new Error('Failed to fetch user data');
        }

        login({
          userId: data.userId,
          username: data.name, 
          user_permission_id: userData.user_permission_id
        });

        navigate('/ideationPlatform');
      } else {
        setErrorMessage(data.error);
      }
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      setErrorMessage('Erro ao tentar fazer login. Tente novamente.');
    }
  };

  return (
    <Grid container className="container" style={{ height: '100vh' }}>
      {/* Seção da esquerda */}
      <Grid
        item
        xs={12}
        sm={6}
        className="left-section"
        style={{
          backgroundColor: '#f5f8fc',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          textAlign: 'center',
          position: 'relative',
        }}
      >
       <Typography 
  variant="h3" 
  gutterBottom
  style={{
    color: '#000000',
    textShadow: `
      0 0 10px #fff,
      0 0 10px #fff,
      0 0 10px #fff,
      0 0 10px #fff
    `,
    fontWeight: 'bold'
  }}
>
  Your gateway to food innovation!
</Typography>
<Typography 
  variant="h5" 
  gutterBottom
  style={{
    color: '#000000',
    textShadow: `
      0 0 8px #fff,
      0 0 8px #fff,
      0 0 8px #fff
    `,
    fontWeight: '600'
  }}
>
  Join Hub4Food<sup>®</sup>
</Typography>
        {/* Texto no fundo */}
        <div className="left-section-footer">
          <Typography variant="body2">
            Don't have an account?{' '}
            <Link to="/register" style={{ color: '#007bff', textDecoration: 'none' }}>
              Sign Up
            </Link>
          </Typography>
        </div>
      </Grid>

      {/* Seção da direita */}
      <Grid
        item
        xs={12}
        sm={6}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px',
        }}
      >
        <img
          src="/logotipo.png"
          alt="Hub4Food Logo"
          className="logo"
          style={{ width: isMobile ? '60px' : '80px', marginBottom: '20px' }}
        />
        <Typography variant="h5" gutterBottom>
          Welcome Back!
        </Typography>
        <form
          id="login-form"
          onSubmit={handleLogin}
          style={{ width: '100%', maxWidth: '300px' }}
        >
           <TextField
            label="Username or Email"
            variant="outlined"
            fullWidth
            value={usernameOrEmail}
            onChange={(e) => setUsernameOrEmail(e.target.value)}
            required
            margin="normal"
            placeholder="Username or email"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountBoxIcon />
                </InputAdornment>
              ),
            }}
          />
          
          {/* Campo Password */}
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            margin="normal"
            placeholder="Enter your password"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="login-button"
            style={{
              width: '100%',
              marginTop: '10px',
              padding: '10px',
              fontSize: '16px',
            }}
          >
            Login
          </Button>
        </form>

        {errorMessage && (
          <Typography
            color="error"
            className="error-message"
            style={{ marginTop: '10px', textAlign: 'center' }}
          >
            {errorMessage}
          </Typography>
        )}
   
<Typography variant="body2" style={{ marginTop: '20px' }}>
  <Link to="/password-recovery" style={{ color: '#007bff', textDecoration: 'none' }}>
    Forgot your password?
  </Link>
</Typography>

      </Grid>
    </Grid>
  );
}

export default Login;
 